import * as React from 'react';
import styled from '../../utils/styled';
import Ellipsis from '../Ellipsis';
import Icon, {IconName} from '../Icon';
import {MenuItemProps} from './types';

const Root = styled('div')<{disabled: boolean; active: boolean}>(
  {
    color: '#C5CAD4',
    borderBottom: '1px solid #10090A',
    borderLeft: '2px solid transparent',
    display: 'block',
    lineHeight: '1.5',
    cursor: 'pointer',
    transition: 'background-color .3s ease-in-out',
    userSelect: 'none',
    position: 'relative',
    height: 65,
    boxSizing: 'border-box',
    a: {
      color: '#C5CAD4',
      textDecoration: 'none',
      display: 'flex',
      alignItems: 'center',
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      paddingLeft: 21
    },
    ':hover': {
      color: '#fff',

      a: {
        color: '#fff'
      }
    },
    i: {
      marginRight: 24
    }
  },
  ({active}) => {
    if (active) {
      return {
        color: '#fff',
        fontWeight: 400,
        borderLeft: '2px solid #FEC34C',
        a: {
          color: '#fff'
        }
      };
    }
    return {};
  },
  ({disabled}) => {
    if (disabled) {
      return {
        color: '#ddd',
        cursor: 'not-allowed',
        a: {
          color: '#ddd'
        }
      };
    }
    return {};
  }
);

export default class MenuItem extends React.Component<MenuItemProps, {}> {
  public render() {
    const {
      label,
      icon,
      href,
      active,
      disabled,
      render: customRender,
      ...restProps
    } = this.props;
    const onClick = !disabled && !href ? this.props.onClick : undefined;

    let contents;

    if (customRender) {
      contents =
        typeof customRender === 'function'
          ? customRender({label, icon, active, disabled, href})
          : customRender;
    } else {
      const truncatedLabel = <Ellipsis>{label}</Ellipsis>;

      contents =
        href && !disabled ? (
          <a href={href}>
            {this._renderIcon}
            {truncatedLabel}
          </a>
        ) : (
          truncatedLabel
        );
    }

    return (
      <Root
        onClick={onClick}
        active={Boolean(active)}
        disabled={Boolean(disabled)}
        {...restProps}
      >
        {contents}
      </Root>
    );
  }

  private _renderIcon() {
    const {icon} = this.props;

    if (typeof icon === 'string') {
      return <Icon name={icon as IconName} />;
    }
    return icon;
  }
}



// WEBPACK FOOTER //
// ./src/components/Menu/MenuItem.tsx